import ModalContainer from "components/common/ModalContainer";
import ReactMarkdown from "react-markdown";

type FlowInsightModalProps = {
    insightsModal: boolean;
    setInsightsModal: (value: boolean) => void;
    summary: string;
    insightsSummary: string;
    insightsRecommendations: Record<string, any>[];
};

const FlowInsightModal = ({
    insightsModal,
    setInsightsModal,
    summary,
    insightsSummary,
    insightsRecommendations,
}: FlowInsightModalProps) => {
    return (
        <ModalContainer
            open={insightsModal}
            modalClassName={"py-10 px-10"}
            tailwindClassName="md:w-[620px] w-[90%] "
            showCloseIcon={false}
            closeModal={() => {
                setInsightsModal(false);
            }}
        >
            <div className="bg-white   shadow-cardShadow  rounded-[8px]">
                <div className="flex items-center justify-between px-6 py-3 border-b border-b-slate-200">
                    <div className="flex items-center gap-2">
                        {summary === "inventory" ? (
                            <div className="w-5 h-5 flex items-center justify-center rounded bg-[#344DB7]">
                                <i className="ri-box-2-fill text-white text-[10px]"></i>
                            </div>
                        ) : summary === "sales" ? (
                            <div className="w-5 h-5 flex items-center justify-center rounded bg-[#FA9600]">
                                <i className="ri-currency-line text-[#FFFBEB] text-[10px]"></i>
                            </div>
                        ) : (
                            <div className="w-5 h-5 flex items-center justify-center rounded bg-[#FD700B]">
                                <i className="ri-file-list-3-fill text-slate-100 text-[10px]"></i>
                            </div>
                        )}

                        <h1 className="text-base text-[#142837] font-rocGroteskMedium">
                            {summary === "inventory"
                                ? "Inventory (AI-generated insight)"
                                : summary === "sales"
                                ? "Sales MTD (AI-generated insight)"
                                : "Incoming PO (AI-generated insight)"}
                        </h1>
                    </div>
                    <i
                        className="ri-close-line text-g-75 text-lg cursor-pointer -mt-2"
                        onClick={() => {
                            setInsightsModal(false);
                        }}
                    ></i>
                </div>
                {insightsSummary && insightsRecommendations?.length > 0 ? (
                    <div className="px-6 py-4 h-[511px] max-h-[70vh] overflow-y-auto">
                        <div className="mb-6 pb-6 border-b border-b-slate-100">
                            <p className="text-slate-500 text-xs mb-1">Summary</p>
                            <p className="text-g-75 text-sm !font-rocGroteskRegular">
                                {insightsSummary}
                            </p>
                        </div>

                        <div className="">
                            <p className="bg-gradient-to-r from-[#56B648] to-[#FFB902] bg-clip-text text-transparent text-xs mb-1">
                                Recommendation
                            </p>
                            <ol className="text-g-75  text-sm list-decimal list-outside pl-4 space-y-2">
                                {insightsRecommendations?.map((item: any) => (
                                    <li key={item?.id} className="!font-rocGroteskRegular ">
                                        <ReactMarkdown>{item}</ReactMarkdown>
                                    </li>
                                ))}
                            </ol>
                        </div>
                    </div>
                ) : (
                    <div className="flex items-center justify-center h-[511px] max-h-[70vh]">
                        {summary === "inventory" ? (
                            <div className="flex items-center flex-col justify-center h-full max-w-[436px]">
                                <div className="mb-4 w-8 h-8 flex items-center justify-center rounded-[6px] bg-[#344DB7]">
                                    <i className="ri-box-2-fill text-b-25 text-[16px]"></i>
                                </div>
                                <p className="text-g-75 text-base mb-1">No AI insights yet</p>
                                <p className="text-sm text-slate-500 text-center">
                                    Synth couldn't generate inventory health insights because
                                    there's no recent stock data available. Once inventory updates,
                                    you'll see AI-driven health scores and risk alerts here.
                                </p>
                            </div>
                        ) : summary === "sales" ? (
                            <div className="flex items-center flex-col justify-center h-full max-w-[436px]">
                                <div className="mb-4 w-8 h-8 flex items-center justify-center rounded bg-[#FA9600]">
                                    <i className="ri-currency-line text-white text-[16px]"></i>
                                </div>
                                <p className="text-g-75 text-base mb-1">No AI sales insights yet</p>
                                <p className="text-sm text-slate-500 text-center">
                                    Synth couldn't generate sales insights for this month. As new
                                    sales orders sync in, you'll get AI-powered performance
                                    summaries and growth signals here.
                                </p>
                            </div>
                        ) : (
                            <div className="flex items-center flex-col justify-center h-full max-w-[436px]">
                                <div className="mb-4 w-8 h-8 flex items-center justify-center rounded-[6px] bg-[#FD700B]">
                                    <i className="ri-file-list-3-fill text-slate-100 text-base"></i>
                                </div>
                                <p className="text-g-75 text-base mb-1">No AI PO insights yet</p>
                                <p className="text-sm text-slate-500 text-center">
                                    Synth hasn't generated any purchase order insights yet. Once new
                                    POs are scheduled or updated, AI recommendations on fulfillment
                                    and timing will appear here.
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </ModalContainer>
    );
};

export default FlowInsightModal;
